import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { LocalStorageService } from '../../../core/local-storage/local-storage.service';
import { SessionStorageService } from '../../../core/session-storage/session-storage.service';
import { UiHelperService } from '../../../core/ui-helper/ui-helper.service';
import { shopInfoKey } from '../../constants/storage-key-constants';
import { UserRole } from '../../enum/user-role.enum';
import { Shop } from '../../models/shop.model';

@Component({
  selector: 'app-header-user-info-sidebar',
  templateUrl: './header-user-info-sidebar.component.html',
  styleUrls: ['./header-user-info-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserInfoSidebarComponent implements OnChanges {

  @Input() open: boolean;
  @Input() fullName = '';

  @Output() closeUserModalEvent = new EventEmitter<boolean>();

  isModalClass = false;

  constructor(
    private uiHelperService: UiHelperService,
    private authService: AuthService,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.open) {
      this.applyModalClass();
    }
  }

  applyModalClass() {
    if (this.open) {
      this.isModalClass = this.uiHelperService.isModalClassApplied();
      if (!this.isModalClass) {
        this.uiHelperService.onInitPopup();
      }
    } else {
      if (!this.isModalClass) {
        this.uiHelperService.onClosePopup();
      }
    }
  }

  closeUserModal() {
    this.closeUserModalEvent.emit(true);
  }

  signOutUser() {
    this.closeUserModal();
    const shopInfo = <Shop>(this.sessionStorage.getItem(shopInfoKey));
    if (shopInfo && shopInfo.shopUid) {
      if (this.authService.isRoleAvailable(UserRole.SHOP_OWNER)) {
        this.localStorage.clear();
      }
      this.sessionStorage.clear();
      this.sessionStorage.setSessionInfo();
      this.uiHelperService.refreshPage(`${shopInfo.shopUid}`);
      this.uiHelperService.roleUpdate(true);
    }
  }

}
